import React, { useState, useEffect } from "react";
import SearchBar from "../layout/SearchBar";
import CustomerTable from "./CustomerTable";
import {
  getCustomersData,
  getReferralCodes,
  deleteCustomer
} from "../../actions/CustomerAction";
import Pagination from "../layout/Pagination";
import Loading from "../layout/Loading";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Calendar } from "lucide-react";
import DropdownBox from "../layout/DropdownBox";
import Header from "./Header";
import { ReactComponent as GroupIcon } from "../../assets/admin/Group.svg";
import { MynauiEditOne } from "../../assets/icons/icons";
import { ReactComponent as AdjustmentsIcon } from '../../assets/admin/Adjustments.svg';
import { Trash2 } from "lucide-react";
import EditCustomerDetails from "./EditCustomerDetails";
import ConfirmDialogBoxWithUser from "../layout/ConfirmDialogBoxWithUser";
import { formatDate } from "../../utils/DateFormat";
import { getStatusStyle } from "./CustomerTable";

const CustomerTableOverview = ({ searchTerm, setSearchTerm }) => {
  // For column selection popup
  const allHeaders = [
    { key: "uid", label: "Number" },
    { key: "createdAt", label: "Date Joined" },
    { key: "mobileNumber", label: "Mobile Number" },
    { key: "email", label: "Email Address" },
    { key: "referral.code", label: "Referral Code" },
    { key: "status", label: "Status" },
    { key: "action", label: "Action" }
  ];
  const [selectedColumns, setSelectedColumns] = useState(allHeaders.map(h => h.key));
  const handleColumnToggle = (key) => {
    setSelectedColumns((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };
  const handleResetColumns = () => {
    setSelectedColumns(allHeaders.map(h => h.key));
  };
  const [filters, setFilters] = useState({
    referralCode: "",
    fromDate: "",
    toDate: "",
  });
    // Edit/Delete logic for mobile actions
    const [confirmEditDialog, setConfirmEditDialog] = useState(false);
    const [confirmDeleteDialogBox, setConfirmDeleteDialogBox] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [userName, setUserName] = useState("");

    const handleEditCustomer = (customerId) => {
      const customerToEdit = customers.find((customer) => customer._id === customerId);
      setSelectedCustomer(customerToEdit);
      setConfirmEditDialog(true);
    };
    const handleConfirmDeleteDialogBox = (customerId) => {
      const customerToDelete = customers.find((customer) => customer._id === customerId);
      setSelectedCustomer(customerToDelete);
      setConfirmDeleteDialogBox(true);
  };

  const handleDeleteCustomer = async (customerId, name) => {
    if (!name) {
      toast.error("Enter your username.");
      return;
    }
    try {
      const response = await deleteCustomer(customerId);
      if (response?.success) {
        toast.success(response.message || "Customer deleted successfully.");
        setUserName("");
        setConfirmDeleteDialogBox(false);
        fetchCustomerData(localSearchTerm, currentPage, itemsPerPage, filters);
      } else {
        toast.error(response?.message || "Failed to delete customer.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");
  const [referralOptions, setReferralOptions] = useState([
    { id: "", code: "ALL" },
     { id: "NA", code: "N/A" },
  ]);
  const [appliedReferralCode, setAppliedReferralCode] = useState("ALL");
  // Popup states for mobile actions
  const [showColumnPopup, setShowColumnPopup] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const fetchReferralCodes = async () => {
    try {
      const response = await getReferralCodes();
      if (response.success) {
        const codes = [{ id: "", code: "ALL" }, { id: "NA", code: "N/A" }, ...response.referralCodes];
        setReferralOptions(codes);
      } else {
        // toast.error(response.message || "Failed to fetch referral codes.");
      }
    } catch (err) {
      toast.error("Error fetching referral codes.");
    }
  };
  const fetchCustomerData = async (
  search,
  currentPage,
  itemsPerPage,
  filterValues = {}
) => {
  const pagination = {
    page: currentPage,
    limit: itemsPerPage,
  };
  
  // Handle N/A referral filter
  let referralValue = filterValues.referralCode || "";
  let hasReferral = undefined;
  
  if (filterValues.referralCode === "NA") {
    // N/A selected - filter for customers without referral
    hasReferral = "false";
    referralValue = "";
  } else if (filterValues.referralCode && filterValues.referralCode !== "") {
    // Specific referral selected
    referralValue = filterValues.referralCode;
    hasReferral = "true";
  }
  // else: All selected (empty), return all customers
  
  try {
    setLoading(true);
    const response = await getCustomersData({
      pagination,
      search,
      filter: {
        referral: referralValue,
        fromDate: filterValues.fromDate || "",
        toDate: filterValues.toDate || "",
        ...(hasReferral !== undefined && { hasReferral }), // Include only if defined
      },
    });

    if (response.success) {
      setCustomers(response.data);
      setTotalPages(response.totalPages || 1);
      setTotalCount(response.totalCount || 0);
      setCurrentPage(response.currentPage || currentPage);
    } else {
      toast.error(response.message || "Failed to fetch customer data.");
    }
  } catch (error) {
    toast.error(
      "Something went wrong while fetching data. Please try again."
    );
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchReferralCodes();
    fetchCustomerData(searchTerm, currentPage, itemsPerPage, filters);
  }, [searchTerm, currentPage, itemsPerPage]);

  const applyFilters = () => {
    if (!validateDateRange(filters.fromDate, filters.toDate)) return;
    setAppliedReferralCode(
      referralOptions.find((ref) => ref.id === filters.referralCode)?.code ||
        "All"
    );
    setCurrentPage(1);
    fetchCustomerData(localSearchTerm, 1, itemsPerPage, filters);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const refreshPage = () => {
    fetchCustomerData(localSearchTerm, currentPage, itemsPerPage);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const handleToDateChange = (e) => {
    const newDate = e.target.value;
    setFilters((prevFilters) => ({ ...prevFilters, toDate: newDate }));
  };

  const handleFromDateChange = (e) => {
    const newDate = e.target.value;
    setFilters((prevFilters) => ({ ...prevFilters, fromDate: newDate }));
  };

  const resetFilters = () => {
    const emptyFilters = {
      referralCode: "",
      fromDate: "",
      toDate: "",
    };
    setSearchTerm("");
    setFilters(emptyFilters);
    setAppliedReferralCode("ALL");
    setCurrentPage(1);
    fetchCustomerData("", 1, itemsPerPage, emptyFilters);
  };

  const validateDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return true;
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);

    if (isNaN(from.getTime()) || isNaN(to.getTime())) {
      toast.error("Invalid date format");
      return false;
    }

    if (from > to) {
      toast.error("From date must be before or equal to the To date");
      return false;
    }

    return true;
  };

  return (
    <>
      <Header filters={filters} searchTerm={searchTerm} />
      <div className="px-4 sm:px-10">
        {/* Mobile view */}
        <div className="block md:hidden">
          <div className="flex flex-row items-center w-full gap-2 pt-4">
            <div className="flex-1 flex items-center h-9">
              <SearchBar
                searchTerm={localSearchTerm}
                onChange={value => setLocalSearchTerm(value)}
                onSearch={() => setSearchTerm(localSearchTerm)}
                className="w-full"
              />
            </div>
            <div className="flex items-center">
              <button
                className="flex items-center justify-center h-9 p-0"
                aria-label="Group"
                style={{ minWidth: 40, borderRadius: '6px', border: '1px solid #E5E7EB', background: '#FFF', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}
                onClick={() => setShowColumnPopup(true)}
              >
                <GroupIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>
            <div className="flex items-center">
              <button
                className="flex items-center justify-center h-9 p-0"
                aria-label="Filter"
                style={{ minWidth: 40, borderRadius: '6px', border: '1px solid #E5E7EB', background: '#FFF', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}
                onClick={() => setShowMobileFilter(true)}
              >
                <AdjustmentsIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>
          </div>
          <div className="flex gap-2">
            <div className="border border-gray-200 rounded-lg flex-1 flex mt-5">
              <div className="flex-1 p-2  gap-2 max-w-[129px]">
                <div className="text-gray-500 text-[12px] sm:text-xs uppercase font-medium w-fit mb-2">REFERRAL CODE</div>
                <div className="text-[18px] sm:text-lg font-bold text-text1">{appliedReferralCode || '-'}</div>
              </div>
              <div className="flex-1 p-1 py-2  border-l border-gray-200 ">
                <div className="text-gray-500 text-[12px] sm:text-xs uppercase font-medium mb-2">TOTAL NO.OF CUSTOMERS JOINED</div>
                <div className="text-[18px] sm:text-lg font-bold text-text1">{totalCount}</div>
              </div>
            </div>
          </div>
          <div className="mt-4 flex flex-col gap-0">
            {/* Popups for mobile actions */}
            {showColumnPopup && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={() => setShowColumnPopup(false)}>
                <div className="bg-white rounded-lg p-6 w-80 max-w-sm shadow-lg" onClick={e => e.stopPropagation()}>
                  <h2 className="text-lg font-semibold mb-4">Edit columns</h2>
                  <div className="flex flex-col mb-4">
                    {allHeaders.map((header, idx) => (
                      <React.Fragment key={header.key}>
                        <label className="flex items-center gap-2 text-base py-2">
                          <input
                            type="checkbox"
                            checked={selectedColumns.includes(header.key)}
                            onChange={() => handleColumnToggle(header.key)}
                            className="accent-primary w-4 h-4"
                          />
                          <span>{header.label} <span className="text-xs text-gray-400"></span></span>
                        </label>
                        {idx < allHeaders.length - 1 && (
                          <hr className="border-t border-gray-200" />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="flex justify-end gap-2 mt-2">
                    <button
                      onClick={handleResetColumns}
                      className="border border-gray-300 rounded-md px-4 py-2 text-sm font-medium bg-white text-gray-700"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => setShowColumnPopup(false)}
                      style={{ backgroundColor: '#22C55E' }}
                      className="text-white rounded-md px-4 py-2 text-sm font-medium"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showMobileFilter && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={() => setShowMobileFilter(false)}>
                <div className="bg-white rounded-lg p-4 w-11/12 max-w-sm" onClick={e => e.stopPropagation()}>
                  <h2 className="text-lg font-semibold mb-4">Filter Customers</h2>
                <div className="mb-3">
                    <label className="primary_label">Referral code</label>
                    <DropdownBox
                      optionList={referralOptions.map((ref) => ref.code)}
                      styleName="w-full text-sm font-normal text-text1 focus:outline-none"
                      value={
                        referralOptions.find(
                          (ref) => ref.id === filters.referralCode
                        )?.code || "All"
                      }
                      placeholder="Select referral code"
                      handleChange={(selectedCode) => {
                        const selected = referralOptions.find(
                          (ref) => ref.code === selectedCode
                        );
                        handleChange({
                          target: { 
                            name: "referralCode", 
                            value: selected?.id || "" 
                          },
                        });
                      }}
                      emptyStringName="All"
                      searchable={true} 
                    />
                  </div>
                  <div className="mb-3">
                    <label className="primary_label">From Date</label>
                    <input
                      type="date"
                      className="primary_input"
                      value={filters.fromDate}
                      onChange={handleFromDateChange}
                      max={filters.toDate}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="primary_label">To Date</label>
                    <input
                      type="date"
                      className="primary_input"
                      value={filters.toDate}
                      onChange={handleToDateChange}
                      min={filters.fromDate}
                    />
                  </div>
                  <div className="flex gap-2 mt-4">
                    <button
                      onClick={() => {
                        resetFilters();
                        setShowMobileFilter(false);
                      }}
                      className="secondary_button inactive flex-1 text-[12px] sm:text-sm"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => {
                        applyFilters();
                        setShowMobileFilter(false);
                      }}
                      className="secondary_button active flex-1 text-[12px] sm:text-sm"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            )}
            {loading ? (
              <Loading />
            ) : (
              customers && customers.length > 0 ? (
                customers.map((customer) => (
                  <table key={customer._id} className="w-full border border-gray-200 rounded-none bg-white shadow-sm">
                    <tbody>
                      {[{ key: "uid", label: "Number" },
                        { key: "createdAt", label: "Date Joined" },
                        { key: "mobileNumber", label: "Mobile Number" },
                        { key: "email", label: "Email Address" },
                        { key: "referral.code", label: "Referral Code" },
                        { key: "status", label: "Status", isStatus: true },
                        { key: "action", label: "Action", isAction: true }
                      ].map((header) => (
                        <tr key={header.key}>
                          <td className="py-2 px-2 text-[16px] font-medium font-rubik text-gray-900 w-1/2 align-top">{header.label}</td>
                          <td className="py-2 px-2 text-[16px] font-normal font-rubik text-gray-700 w-1/2 align-top break-words max-w-[140px] overflow-hidden text-ellipsis">
                            {header.key === "createdAt" ? (
                              customer[header.key] ? formatDate(customer[header.key]) : "N/A"
                            ) : header.isStatus ? (
                              <span className={`px-3 py-1 rounded-full font-medium ${getStatusStyle(customer.status)}`}>{customer.status || ""}</span>
                            ) : header.key === "referral.code" ? (
                              customer.referral?.code ? customer.referral.code : "N/A"
                            ) : header.key === "email" ? (
                              customer.email ? customer.email : "N/A"
                            ) : header.isAction ? (
                              <div className="flex gap-2 items-center">
                                <button className="p-2 rounded" onClick={() => handleEditCustomer(customer._id)} aria-label="Edit">
                                  <MynauiEditOne className="text-gray-400 w-5 h-5" />
                                </button>
                                <button className="p-2 rounded" onClick={() => handleConfirmDeleteDialogBox(customer._id)} aria-label="Delete">
                                  <Trash2 className="text-gray-400 w-5 h-5" />
                                </button>
                              </div>
                            ) : (
                              customer[header.key] || "N/A"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ))
              ) : (
                <div className="text-center text-gray-500 p-4 bg-white border border-gray-200 rounded-lg">No customers found</div>
              )
            )}
            {/* Render edit and delete dialogs for mobile view */}
            {confirmEditDialog && selectedCustomer && (
              <EditCustomerDetails
                customer={selectedCustomer}
                closeModal={() => setConfirmEditDialog(false)}
                refreshData={() => {
                  setConfirmEditDialog(false);
                  // Optionally refresh data after edit
                  fetchCustomerData(localSearchTerm, currentPage, itemsPerPage, filters);
                }}
              />
            )}
            {confirmDeleteDialogBox && selectedCustomer && (
              <ConfirmDialogBoxWithUser
                handleCancel={() => setConfirmDeleteDialogBox(false)}
                message="You're about to <strong> delete the customer data. </strong>Please confirm by entering your username."
                type="inactive"
                handleConfirm={() =>
                  handleDeleteCustomer(selectedCustomer._id, userName)
                }
                userName={userName}
                setuserName={setUserName}
                confirmMessage="Confirm & Delete"
              />
            )}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={handlePageChange}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
        </div>

        {/* Desktop view */}
        <div className="hidden md:block">
          <div>
            {/* Filter Fields */}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
              {/*  From Date */}
              <div className="flex-1">
                <label htmlFor="fromDate" className="primary_label">
                  From date
                </label>
                <div className="relative mt-1">
                  <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                    <Calendar className="text-md text-gray-500 h-5 w-5" />
                  </div>
                  <div className="pl-10">
                    <input
                      type="date"
                      id="fromDate"
                      name="fromDate"
                      className="w-full text-text1 py-[10px] px-5 border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                      value={filters.fromDate}
                      onChange={handleFromDateChange}
                      max={filters.toDate}
                    />
                  </div>
                </div>
              </div>
              {/*   To Date */}
              <div className="flex-1">
                <label htmlFor="toDate" className="primary_label">
                  To date
                </label>
                <div className="relative mt-1">
                  <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                    <Calendar className="text-md text-gray-500 h-5 w-5" />
                  </div>
                  <div className="pl-10">
                    <input
                      type="date"
                      id="toDate"
                      name="toDate"
                      className="w-full text-text1 py-[10px] px-5 border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                      value={filters.toDate}
                      onChange={handleToDateChange}
                      min={filters.fromDate}
                    />
                  </div>
                </div>
              </div>
              {/* Referral Dropdown */}
              <div>
                <label className="primary_label">Referral code</label>
                <div>
                 <DropdownBox
                  optionList={referralOptions.map((ref) => ref.code)}
                  styleName="w-full focus:outline-none text-sm font-normal text-text1"
                  value={
                    referralOptions.find(
                      (ref) => ref.id === filters.referralCode
                    )?.code || "All"
                  }
                  handleChange={(selectedCode) => {
                    const selected = referralOptions.find(
                      (ref) => ref.code === selectedCode
                    );
                    handleChange({
                      target: {
                        name: "referralCode",
                        value: selected?.id || "",
                      },
                    });
                  }}
                  emptyStringName="All"
                  searchable={true} 
                />
                </div>
              </div>
            </div>

            {/* Submit & Reset Buttons */}
            <div className="mt-4 gap-3 flex justify-end items-center">
              <button
                onClick={resetFilters}
                className="secondary_button inactive"
                disabled={loading}
              >
                Reset
              </button>
              <button
                onClick={applyFilters}
                className="secondary_button active"
                disabled={loading}
              >
                <span className={`${loading ? "px-0" : "px-4"}`}>
                  {loading ? "Applying.." : "Apply"}
                </span>
              </button>
            </div>
          </div>
          <hr className="mt-4" />
          {loading ? (
            <>
              <Loading />
            </>
          ) : (
            <>
              <div className="mt-10 space-y-6">
                <CustomerTable
                  customers={customers}
                  setCustomers={setCustomers}
                  refreshData={refreshPage}
                  searchTerm={searchTerm}
                  totalCustomers={totalCount}
                  setSearchTerm={setSearchTerm}
                  filters={filters}
                  referralCode={appliedReferralCode}
                />

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                  onPageChange={handlePageChange}
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={handleItemsPerPageChange}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerTableOverview;
